export default __webpack_public_path__ + "static/DSC_0142-9a51807a5ef915dd73cabed698ff1d7f.jpg";